/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.preload)();
	(0, _module.anchorLink)();
	(0, _module.toggleNav)();
	(0, _module.toggleProf)();
	(0, _module.toggleMovie)();
	(0, _module.animeScroll)();
	(0, _module.animeLoad)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listTotop = exports.animeLoad = exports.animeScroll = exports.bnrToggle = exports.toggleMovie = exports.toggleProf = exports.toggleNav = exports.middleSlider = exports.topSlider = exports.anchorLink = exports.loading = exports.preload = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	var getCookie = function getCookie() {
	  var arr = new Array();
	
	  if (document.cookie != '') {
	    var tmp = document.cookie.split('; ');
	
	    for (var i = 0; i < tmp.length; i++) {
	      var data = tmp[i].split('=');
	      arr[data[0]] = decodeURIComponent(data[1]);
	    }
	  }
	
	  return arr;
	};
	
	function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	} // preload
	
	
	var preload = function preload() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkAdjust = 0;
	
	    if (linkHref == "#" || linkHref == "") {
	      var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	      var linkPosition = linkTarget.offset().top;
	    } else {
	      var linkPosition = document.querySelector(linkHref).offsetTop;
	    }
	
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// topSlider
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var topSlider = function topSlider() {
	  $(function () {
	    var targetElm = $(".op-list_current");
	    var swiper = new Swiper('.op-wrapper', {
	      speed: 600,
	      threshold: 10,
	      touchRatio: 0.9,
	      slidesPerView: 'auto',
	      autoHeight: false,
	      navigation: {
	        nextEl: '.op-list_next',
	        prevEl: '.op-list_prev'
	      },
	      loop: true,
	      on: {
	        init: function init() {
	          targetElm.text("01");
	        }
	      }
	    });
	    swiper.on('transitionStart', function () {
	      targetElm.addClass("progress");
	    });
	    swiper.on('transitionEnd', function () {
	      var currentIdx = swiper.realIndex + 1;
	      targetElm.text(("0" + currentIdx).slice(-2));
	      targetElm.removeClass("progress");
	    });
	  });
	}; // ------------------------------------------------------------------------
	// middleSlider
	// ------------------------------------------------------------------------
	
	
	exports.topSlider = topSlider;
	
	var middleSlider = function middleSlider() {
	  $(function () {
	    var swiper = new Swiper('.ac-wrapper', {
	      speed: 600,
	      threshold: 10,
	      touchRatio: 0.9,
	      slidesPerView: 'auto',
	      centeredSlides: true,
	      autoHeight: false,
	      navigation: {
	        nextEl: '.ac-list_next',
	        prevEl: '.ac-list_prev'
	      },
	      loop: true,
	      pagination: {
	        el: '.ac-list_pager',
	        clickable: true,
	        renderBullet: function renderBullet(index, className) {
	          // 下のサムネイルブロックを出力
	          // let targetImage = swiper.slides[index].attr('data-profile');
	          var targetImage = this.slides[index].dataset.profile; // console.log(targetImage)
	
	          return '<div class="' + className + '"><div class="swiper-pagination-bullet-image" style="background:url(./assets/images/common/profile/' + targetImage + ') no-repeat;background-size:cover;background-position:center;">' + '</div></div>';
	        }
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// toggleNav
	// ------------------------------------------------------------------------
	
	
	exports.middleSlider = middleSlider;
	
	var toggleNav = function toggleNav() {
	  $(".header-hamburger_button , .header-anchor").on("click", function () {
	    if ($(".st-Profile").hasClass("open")) {
	      $(".st-Profile").toggleClass("open");
	      $(".header-hamburger_button").toggleClass("open-profile");
	      $(".header-hamburger_button").toggleClass("open");
	      $(".header-hamburger").toggleClass("open");
	      setTimeout(function () {
	        $(".profile-wrapper").removeClass("visible");
	      }, 300);
	    } else if ($(".st-Movie").hasClass("open")) {
	      $(".st-Movie").toggleClass("open");
	      $(".header-hamburger_button").toggleClass("open-movie");
	      $(".header-hamburger_button").toggleClass("open");
	      $(".header-hamburger").toggleClass("open");
	      videoControl("stopVideo", '#youtube-modal');
	    } else {
	      $(".header-hamburger_button").toggleClass("open");
	      $(".header-hamburger").toggleClass("open");
	      $(".header-nav").toggleClass("open");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// toggleProf
	// ------------------------------------------------------------------------
	
	
	exports.toggleNav = toggleNav;
	
	var toggleProf = function toggleProf() {
	  $(window).on("load", function () {
	    $(".item-profile_toggle").on("click", function () {
	      var profileId = "#profile-" + $(this).data("number"); // console.log(profileId);
	
	      $(".st-Profile").toggleClass("open");
	      $(profileId).toggleClass("visible");
	      $(".header-hamburger_button").toggleClass("open-profile");
	      $(".header-hamburger_button").toggleClass("open");
	      $(".header-hamburger").toggleClass("open");
	    });
	  });
	}; // ------------------------------------------------------------------------
	// toggleMovie
	// ------------------------------------------------------------------------
	
	
	exports.toggleProf = toggleProf;
	
	var toggleMovie = function toggleMovie() {
	  var ua = navigator.userAgent;
	  $(".st-Movie_Toggle").on("click", function () {
	    var youtubeId = $(this).data("movie");
	    var embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=1&enablejsapi=1";
	    $(".st-Movie").toggleClass("open");
	    $(".header-hamburger_button").toggleClass("open-movie");
	    $(".header-hamburger_button").toggleClass("open");
	    $(".header-hamburger").toggleClass("open");
	    $('#youtube-modal').attr("src", embedUrl);
	    $('#youtube-modal').on('load', function () {
	      videoControl("playVideo", '#youtube-modal');
	
	      if (/android/i.test(ua)) {
	        videoControl("unMute", '#youtube-modal');
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// loading
	// ------------------------------------------------------------------------
	
	
	exports.toggleMovie = toggleMovie;
	
	var loading = function loading() {
	  $(window).on("load", function () {
	    // let embedUrl = "https://www.youtube.com/embed/Dm2O_W6Rrss?autoplay=1&mute=1&enablejsapi=1";
	    // $(".st-Movie").toggleClass("open");
	    // $(".header-hamburger_button").toggleClass("open-movie");
	    // $(".header-hamburger_button").toggleClass("open");
	    // $('#youtube-modal').attr("src", embedUrl);
	    // $('#youtube-modal').on('load', function () {
	    //   videoControl("playVideo", '#youtube-modal');
	    //   $(".st-Loading").addClass("loaded");
	    // });
	    var video = document.getElementById('intro-video');
	    video.pause();
	    $(".st-Loading").addClass("loaded"); // video.addEventListener('ended', function() {
	    //   $(".st-Loading").addClass("loaded");
	    // });
	  });
	}; // ------------------------------------------------------------------------
	// bnrToggle
	// ------------------------------------------------------------------------
	
	
	exports.loading = loading;
	
	var bnrToggle = function bnrToggle() {
	  $(window).on("load", function () {
	    var trg = 0;
	    var arr = getCookie();
	
	    if (arr['flag'] == 1) {
	      $('.st-Nextact').addClass("disabled");
	    }
	
	    $(".banner-close").on("click", function () {
	      $(".st-Nextact").removeClass("visible");
	      setTimeout(function () {
	        $('.st-Nextact').addClass("disabled");
	        document.cookie = "flag=1; path=/; max-age=86400";
	      }, 500);
	      trg = 9;
	    });
	    var visibleHeight = $('.idx-Nextact').offset().top - $('.idx-Nextact').outerHeight();
	    gsap.to('.st-Nextact', {
	      scrollTrigger: {
	        trigger: '.idx-Opening',
	        start: 'center center',
	        end: function end() {
	          return visibleHeight;
	        },
	        toggleClass: {
	          targets: ".st-Nextact",
	          className: "visible"
	        }
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// listTotop
	// ------------------------------------------------------------------------
	
	
	exports.bnrToggle = bnrToggle;
	
	var listTotop = function listTotop() {
	  $(window).on("load", function () {
	    console.log("w");
	    var visibleHeight = $('.entrywork').outerHeight() + $('.st-Banner').outerHeight() * 8;
	    gsap.to('.list-totop', {
	      scrollTrigger: {
	        trigger: '.list-anchor',
	        start: 'bottom top',
	        end: function end() {
	          return visibleHeight;
	        },
	        toggleClass: {
	          targets: ".list-totop",
	          className: "visible"
	        }
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// animeScroll
	// ------------------------------------------------------------------------
	
	
	exports.listTotop = listTotop;
	
	var animeScroll = function animeScroll() {
	  $(window).on("load", function () {
	    $(".anim-sc").each(function (i, node) {
	      gsap.to(node, {
	        scrollTrigger: {
	          trigger: node,
	          start: 'top bottom-=200',
	          toggleClass: {
	            targets: node,
	            className: "animated"
	          },
	          once: true
	        }
	      });
	    });
	  });
	}; // ------------------------------------------------------------------------
	// animeLoad
	// ------------------------------------------------------------------------
	
	
	exports.animeScroll = animeScroll;
	
	var animeLoad = function animeLoad() {
	  $(window).on("load", function () {
	    $(".anim-ld").toggleClass("animated");
	  });
	};
	
	exports.animeLoad = animeLoad;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// next/app.bundle.js